import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CKEditor from "ckeditor4-react"
import { sendRequest } from '../../apis/APIs';
import { handleApiResponse } from '../../apis/apiUtils';
import { validationProposalInfoForm } from './ValidationProposalInfoForm';
import { useDispatch } from 'react-redux';
import { callCommonAction } from '../../redux/Common/CommonReducer';

const App = ({ proposalInfoModal, setShowProposalInfoModal }) => {
    const [data, setData] = useState({ projectName: '', description: '', });
    const [errorsInfo, setErrorsInfo] = useState({});
    const navigate = useNavigate();
    const { loading } = useSelector((state) => state.common);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
        setErrorsInfo((prev) => ({ ...prev, [name]: '' }));
    };



    const checkFormIsValid = (fieldName) => {
        const res = validationProposalInfoForm(data, fieldName);
        setErrorsInfo(res.errors);
        return res.formValidCheck;
    };

    // const handleSave = () => {
    //     if (checkFormIsValid('')) {
    //         const { projectName, description } = data;
    //         if (projectName && description) {
    //             setShowProposalInfoModal(false);
    //             navigate('/create-proposal', { state: { data } });
    //         } else {
    //             alert('Please fill in all fields');
    //         }
    //     }
    // };



    const handleSave = async () => {
        if (checkFormIsValid('')) {

            try {
                dispatch(callCommonAction({ loading7: true }))


                const formData = new FormData()
                formData.append("title", data.projectName)
                const stripHtml = (html) => html.replace(/<[^>]*>/g, '').trim();

                formData.append("metatitle", stripHtml(data?.description || ""));
                formData.append("is_draft", "1")

                const apiUrl = "/user/document"
                // Use sendRequest but allow FormData
                const res = await sendRequest(apiUrl, "POST", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data", // Optional; some libraries handle this automatically
                    },
                })
                if (res.data.type === "success") {
                    dispatch(callCommonAction({ loading7: false }))

                    navigate(`/update-proposal/${res?.data?.document?.id}`, {
                        state: {
                            data,
                            firstedit: true // or whatever value you want to pass
                        }
                    });

                    // window.location.reload()
                }
            } catch (error) {
                dispatch(callCommonAction({ loading7: false }))
                console.error("Error during download:", error)
            }
        }

    }
    const handleEditorChange = (name, htmlValue) => {
        setData((prev) => ({ ...prev, [name]: htmlValue }));
        setErrorsInfo((prev) => ({ ...prev, [name]: '' }));
    };



    return (
        <Modal show={proposalInfoModal} onHide={() => setShowProposalInfoModal(false)} centered   dialogClassName="wider-modal">
            <Modal.Header closeButton>
                <Modal.Title className="fs-6">Enter Project Info</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Group className="mb-3">
                        <Form.Label>Project Name*</Form.Label>
                        <Form.Control
                            type="text"
                            name="projectName"
                            placeholder="Enter project name"
                            value={data.projectName}
                            onChange={handleChange}
                        />
                        <div className="error-message small" style={{ color: 'red' }}>{errorsInfo.projectName}</div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description*</Form.Label>
                        <CKEditor
                            initData={data.description}
                            onChange={(event) => handleEditorChange('description', event.editor.getData())}
                            config={{
                                height: 200,
                                extraPlugins: "colorbutton,font,justify,preview,find,flash,forms,iframe,pagebreak",
                                removePlugins: "elementspath",
                                resize_enabled: true,

                                toolbar: [
                                    {
                                        name: "basicstyles",
                                        items: [
                                            "Bold",
                                            "Italic",
                                            "Underline",
                                            "NumberedList",
                                            "BulletedList",
                                            "JustifyLeft",
                                            "JustifyCenter",
                                            "JustifyRight",
                                            "JustifyBlock",
                                            "Image",
                                            "Table",
                                            "TextColor",
                                            "BGColor",
                                            "Styles",
                                            "Format",
                                            "Font",
                                            "FontSize",
                                        ],
                                    },
                                ],
                            }}
                        />
                        <div className="error-message small" style={{ color: 'red' }}>{errorsInfo.description}</div>

                    </Form.Group>


                </Form>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={() => setShowProposalInfoModal(false)} className="btn btn-outline-custom btn-sm px-3 py-2 rounded-3">Close</button>
                <button
                    type="submit"
                    onClick={handleSave}
                    disabled={loading}
                    className="btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3"
                >
                    {
                        loading
                            ? <span className="indicator-progress" style={{ display: 'block' }}>
                                Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                            : <span className="text-uppercase d-flex align-items-center">
                                <iconify-icon icon="tdesign:save" class=" fs-5 me-1"></iconify-icon>
                                Save & Open Editor
                            </span>
                    }
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default App;
